/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import SweetAlert from 'sweetalert2/src/sweetalert2.js';
import { getQuestionnairesFn, deleteQuestionnairesFn } from '../../../api/api';
import { useStateContext } from '../../../contexts/ContextProvider';
import { Trash2 } from 'react-feather';

function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}

function DeleteQuestionnaires({ qstId }) {
  const { basictoaster, setQuestionnaires, setExecuting } = useStateContext();

  const delQstH = () => {
    SweetAlert.fire({
        title: 'Sei sicuro?',
        text: 'Il tuo questionario verrà cancellato',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true
    })
        .then(async (result) => {
          if (result.value) {
            setExecuting(true);
            try {
              const response = await deleteQuestionnairesFn(qstId);
              if (response.Success) {
                SweetAlert.fire(
                  'Fatto!',
                  'Il tuo questionario è stato cancellato.',
                  'success'
                );
              } else if (containsError(response)) {
                SweetAlert.fire(
                  'Errore!',
                  `Errore: ${response.Error}.`,
                  'error'
                );
              }

              // getQuestionnairesFn accetta opzionalmente un AbortSignal, non una stringa
              await getQuestionnairesFn().then((resp) => {
                setQuestionnaires(resp);
              }).catch((err) => {basictoaster("error", "Errore questionari", err, () => {})});
            } catch (err) {
              basictoaster("error", 'Errore eliminazione questionari', err, () => {});
            } finally {
              setExecuting(false);
            }
          }
        }).catch((err) => {basictoaster("error", 'Errore eliminazione questionari', err, () => {})});
  };

  return (
      <button className='imgButton' onClick={delQstH}><Trash2 width={20} /></button>
  );
}

export default DeleteQuestionnaires;
